export default "__VITE_ASSET__b8e465ed__"